import React from 'react';
import cn from 'classnames';
import { Button, CloseButton, Typography } from 'seagull';
import { ExclamationLine24 } from 'seagull/icons';
import styles from "./Banner.module.scss";
export const Banner = props => {
  const {
    title,
    actionButtonLabel,
    actionButtonIntent,
    skin = 'warning',
    'data-testid': testId,
    actionButtonOnClick,
    closeButtonOnClick
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: cn(styles.root, styles["".concat(skin, "Skin")])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement(ExclamationLine24, null), /*#__PURE__*/React.createElement(Typography, {
    as: "p"
  }, title)), /*#__PURE__*/React.createElement(Button, {
    intent: actionButtonIntent,
    "data-testid": "".concat(testId, "-approve-btn"),
    skin: "darkSecondary",
    onClick: actionButtonOnClick
  }, actionButtonLabel), closeButtonOnClick && /*#__PURE__*/React.createElement(CloseButton, {
    onClick: closeButtonOnClick,
    "data-testid": "".concat(testId, "-close-btn")
  }));
};